// @flow

import React from 'react';
import { connect } from 'react-redux';
import { flowRight } from 'lodash';

import { PolicyPendingCheck } from '@zapier/design-system-microlibrary-shared';

import * as Profile from 'app/entities/Profile';
import maybeRender from 'app/common/components/maybeRender';
import { getCurrentPathname } from 'app/common/utils/RouterSelectors';

type Props = {
  pathname: string,
};

const CheckPendingPolicies = ({ pathname }: Props) => (
  <PolicyPendingCheck currentPathname={pathname} />
);

const stripPathSlashes = pathname => pathname.replace(/^\/+|\/+$/gm, '');

const mapStateToProps = state => ({
  pathname: stripPathSlashes(
    getCurrentPathname(state) || window.location.pathname || ''
  ),
  currentProfile: Profile.selectors.all.currentProfile(state),
  isAdminMasqueraded: Profile.selectors.all.isMasquerading(state),
});

export default flowRight(
  connect(mapStateToProps),
  maybeRender(props => !!props.currentProfile && !props.isAdminMasqueraded)
)(CheckPendingPolicies);
